import { Factory } from 'rosie';

Factory.define('Toast').attr('name', 'TOAST');

Factory.define('ToastWithDefaults')
  .extend('Toast')
  .attr('id', 'default-id')
  .attr('message', 'default-message')
  .attr('type', 'INFO');



// WEBPACK FOOTER //
// ./factories/toast_factory.js